import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  title = 'Some error!';
  mainSiteUrl: string;
  constructor(private route: ActivatedRoute) {
	  this.mainSiteUrl = environment.mainSiteUrl
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      if (data.is404) {
        this.title = 'Page not found!';
      }
    });
  }
}
